import '@strapi/icons';
export { G as default } from './chunks/index-BUqiOq3Y.mjs';
import 'byte-size';
import 'date-fns';
import 'qs';
import 'react/jsx-runtime';
import 'react';
import '@strapi/admin/strapi-admin';
import '@strapi/design-system';
import 'react-intl';
import 'styled-components';
import 'react-query';
import 'yup';
import 'formik';
import 'lodash/isEqual';
import 'react-select';
import 'cropperjs';
import '@mux/mux-player-react';
import 'cropperjs/dist/cropper.css';
import 'lodash/isEmpty';
import 'react-dnd';
import 'react-router-dom';
import '@strapi/icons/symbols';
import 'date-fns/parseISO';
//# sourceMappingURL=index.mjs.map
